import { REP_V2 } from '../../../metacloud/src/shared/Data/typeDirs';
import { uploadDropboxFile } from '../services/dropboxRequests'
import { REP_TPL } from '../shared/Data/typeDirs';
import { isBeta } from "./network";

console.log('This code is not in use anymore, so no need to adapt to the web');
console.error('Executing electron code from networkRequests.js. This code that define and use LOC_ROOT should be moved to the server')
/*let remote =
  typeof window === 'undefined' ? null : window.require('@electron/remote')
if (!remote) remote = {Menu: {buildFromTemplate: Function}}
const {app} = remote
const userData = app.getPath('userData')
const LOC_USER_DATA = userData
const LOC_ROOT = `${userData}/photo_store`

// const remote = window.require('@electron/remote')
*/
const LOC_ROOT = ``
const LOC_USER_DATA = ``


// const realBeta = remote.getGlobal('env')
const appUrl = async (ignoreBeta = false) => {
  const ib = await isBeta()
  // console.log('APPURL WITH ISBETA', ib)
  return `${process.env.REACT_APP_APP_URL}${(ib === 'true') && !ignoreBeta ? '/beta' : ''}`
}

const prot = process.env.REACT_APP_PROTOCOL

const createUser = async (userProps, userToken) => {
  return new Promise(async (resolve, reject) => {
    const strikeUrl = `${prot}:${await appUrl()}/files/put?code=${userToken}`
    let body = new FormData()
    // for( const prop of Object.keys(userProps)) {
    //   body.append(prop, userProps[prop])
    // }
    body.append('file', JSON.stringify(userProps))
    body.append('type', 'user_record')

    // body.append('type', type)
    // body.append('file', fileName)
    let res = await fetchPost(body, strikeUrl, userToken)
    return resolve(res)
  })
}

const requestArchive = async (fileName, type, userToken) => {
  return new Promise(async (resolve, reject) => {
    const au = await appUrl()
    const strikeUrl = `${prot}:${au}/files/archive?code=${userToken}`
    console.log('before request archive', strikeUrl, await appUrl(), await isBeta())
    let body = new FormData()
    body.append('type', type)
    body.append('file', fileName)
    let res = await fetchPost(body, strikeUrl, userToken)
    return resolve(res)
  })
}

const requestUnarchive = async (fileName, type, userToken) => {
  return new Promise(async (resolve, reject) => {
    const strikeUrl = `${prot}:${await appUrl()}/files/unarchive?code=${userToken}`
    let body = new FormData()
    body.append('type', type)
    body.append('file', fileName)
    let res = await fetchPost(body, strikeUrl, userToken)
    return resolve(res)
  })
}

const requestDelete = async (fileName, type, userToken) => {
  return new Promise(async (resolve, reject) => {
    const strikeUrl = `${prot}:${await appUrl()}/files/kill?code=${userToken}`
    let body = new FormData()
    body.append('type', type)
    body.append('file', fileName)
    let res = await fetchPost(body, strikeUrl, userToken)
    return resolve(res)
  })
}

const getFileAsBlob = async path => {
  console.log('This code is not in use anymore, so no need to adapt to the web');
  console.error('Executing electron code from networkRequests.js');
  /*return new Promise((resolve, reject) => {
    console.log(fs)
    let img = []
    let f = fs.createReadStream(path)
    f.on('data', data => {
      // console.log(data)
      img.push(data)
      // resolve(data)
    })
    f.on('end', () => {
      // // console.log(err, data)
      // console.log('ending')
      // // let b = new Blob(image, {type: 'image/jpeg'})
      // resolve(new Blob(img, {type: 'image/jpeg'}))
    })
    f.on('close', () => {
      console.log('closing')
      // console.log(err, data)
      resolve(new Blob(img, {type: 'image/jpeg'}))
    })
  })*/
}

function requestFileFromUser(accept = "*", multiple = false) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none'; // invisible
    input.accept = accept;
    input.multiple = multiple;

    // Handle selection
    input.addEventListener('change', () => {
      document.body.removeChild(input);
      if (input.files.length > 0) {

        resolve(multiple ? [...input.files] : input.files[0]);
      } else {
        reject(new Error("No file selected"));
      }
    });

    // Add to DOM and click
    document.body.appendChild(input);
    input.click();
  });
}

const uploadPhoto = async function (
  dir,
  photoId,
  image,
  userToken,
  archiveOnly = false,
  isImageBlob = false,
) {
  // let bodyArgs = {inspection, photoId, image}
  // console.log('uhhhh is betauhhhhh?', isBeta(), realBeta, remote)
  let strikeUrl = `${prot}:${await appUrl()}/photos/receiveImage?code=${userToken}`
  // if(beta) strikeUrl = `${prot}:${await appUrl()}/beta/photos/receiveImage?code=${userToken}`
  console.log('is uhhh ther string uhh right?', image, dir)
  let body = new FormData()
  body.append('dir', dir)
  body.append('photoId', photoId)

  let imageBlob
  if (isImageBlob) {
    imageBlob = image
  } else {
    imageBlob = await getFileAsBlob(image)
  }
  console.log('got image for upload', imageBlob)
  if (archiveOnly) return await uploadDropboxFile(imageBlob, `${dir}/photos/${photoId}.jpg`)
  body.append('image', imageBlob, {
    contentType: 'image/jpeg',
  })
  body.append('archiveOnly', archiveOnly)
  console.log('strikeurl?', strikeUrl, await appUrl(), prot)
  return await fetchPost(body, strikeUrl, userToken)
}

const reuploadPhoto = async function (
  dir,
  photoId,
  dbxPath,
  userToken,
  archiveOnly = false,
) {
  // let bodyArgs = {inspection, photoId, image}
  // console.log('uhhhh is betauhhhhh?', isBeta(), realBeta, remote)
  let strikeUrl = `${prot}:${await appUrl()}/photos/requestDropboxReupload?code=${userToken}`
  // if(beta) strikeUrl = `${prot}:${await appUrl()}/beta/photos/receiveImage?code=${userToken}`
  // console.log('is uhhh ther string uhh right?', strikeUrl)
  let body = new FormData()
  body.append('dir', dir)
  body.append('photoId', photoId)
  body.append('dbxPath', dbxPath)

  body.append('archiveOnly', archiveOnly)
  console.log('strikeurl?', strikeUrl, await appUrl(), prot)
  return await fetchPost(body, strikeUrl, userToken)
}


const checkS3BucketItems = async function (userToken) {
  let strikeUrl = `${prot}:${await appUrl()}/photos/getS3RekognitionList?code=${userToken}`
  await fetchPost(false, strikeUrl, userToken)
}

const uploadRekognitionImagesToS3 = async function (userToken, exclude) {
  let strikeUrl = `${prot}:${await appUrl()}/photos/uploadRekognitionImagesToS3?code=${userToken}`
  let body = new FormData()
  body.append('exclude', exclude)
  await fetchPost(exclude, strikeUrl, userToken)
}

const testDBGEndpoints = async function (userToken) {

  //get virtual-set (collection) list and metadata
  return await fetch(`${prot}:${await appUrl()}/dbGallery/testdbgendpoints`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}

const makeAdmin = async function (userToken) {

  //get virtual-set (collection) list and metadata
  return await fetch(`${prot}:${await appUrl()}/users/makeAdmin`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}

const clearLangV2Tables = async function (userToken) {

  //get virtual-set (collection) list and metadata
  await fetch(`${prot}:${await appUrl()}/files/clearLangV2Tables`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}

const createAndAddDefaultReport = async function (userToken) {

  //get virtual-set (collection) list and metadata
  await fetch(`${prot}:${await appUrl()}/files/createTestReport_v2`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}


const deduplicateReportPhotosInBlocks = async function (file, userToken) {
  let body = new FormData()
  body.append('file', JSON.stringify(file))
  //get virtual-set (collection) list and metadata
  await fetch(`${prot}:${await appUrl()}/files/deduplicateReportPhotosInBlocks`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    body
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}

const clearNewReportTables = async function (userToken) {

  //get virtual-set (collection) list and metadata
  await fetch(`${prot}:${await appUrl()}/files/clearRepV2Tables`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })
  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)


}


const _testnewws = async function (userToken) {
  let strikeUrl = `${prot}:${await appUrl()}/files/testws`
  await fetchPost({}, strikeUrl, userToken)
}

const fetchPost = async function (body, url, userToken) {
  // for(let key in bodyArgs) body.append(key, bodyArgs[key])
  return await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    body,
  }).catch(err => console.log('err', err))
}

const fetchGet = async function (url, userToken) {
  return await fetch(`${prot}:${url}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${userToken}`,
    }
  })

}

const fetchDELETE = async function (path, headers, body) {
  return await fetch(path, {
    method: 'DELETE',
    headers,
    body
  })
}


const simpleUploadImage = async function(path, imageBlob, userToken){
  try{
    let body = new FormData()
    body.append('file', imageBlob, {
      contentType: 'image/jpeg',
    })
    body.append('fileName', imageBlob.name)
    let pre  =await appUrl()
    const root_url = await appUrl()
    const DBG_ROOT = 'dbGallery'
    let res =  await fetch(`${prot}:${root_url}/${DBG_ROOT}/uploadToDBG`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body
    }).catch(err => console.log('err', err))
    const rawText = await res.text(); //this need to be parsed and used in saving image to database
    return JSON.parse(rawText)
  }
  catch(e){
    console.log('Error in simpleUploadImage:', e);
  }
}

const getThumbnails = async function (entries, userToken) {

  // console.log('attempting getThumbnails', entries)  
  let body = new FormData()
  body.append('entries', JSON.stringify(entries))

  let pre = await appUrl()
  console.debug(Date.now() + ` Images: sending ${entries.length} entries to /photos/getThumbnails Recaapp api `);

  // console.log('sending now', body.entries, pre)
  let res = await fetch(`${prot}:${pre}/photos/getThumbnails`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`
    },
    body
  }).catch(err => console.error('Error in getThumbnails:', err));

  // Check if the response is ok
  if (!res.ok) {
    console.error(`HTTP error! status: ${res.status}`, res);
    return []
  }

  // let virtualsets = await resOne.json()
  // console.log('got a res', virtualsets, resOne)
  let res_json = await res.json()
  // console.log('got a res from getThumbnails', res_json.length)
  console.debug(Date.now() + ` Images: geting from /photos/getThumbnails Recaapp api `);
  return res_json
}

const requestExcelExport = async function (_id, userToken, reportName) {
  let body = new FormData()
  body.append('_id', _id)
  let pre = await appUrl()
  let res = await fetch(`${prot}:${pre}/exports/${REP_V2}/xlsx`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userToken}`
    },
    body
  }).catch(err => console.warn('Error attempting excel export', err))

  console.log('got res from export request', res)
  let blob = await res.blob()
  console.log('blob?', blob)
  let url = URL.createObjectURL(new File([blob], `${reportName}.xlsx`, { type: blob.type }))
  const a = document.createElement('a')
  a.href = url
  a.download = `${reportName}.xlsx`
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

const toArray = async function (type, userToken) {
  let pre = await appUrl()
  let body = new FormData()
  body.append('type', type)
  let res = await fetchPost(body, `${prot}:${pre}/files/toArray`, userToken)
  return res.json()
}

const unlockReportBlocksByUser = async function (_id, userToken) {
  let pre = await appUrl()
  let body = new FormData()
  
  return await fetch(`${prot}:${pre}/files/unlockReportBlocksByUser`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json'

    },
    body:JSON.stringify({type:REP_V2, file:{ _id }}),
  }).catch(err => console.log('err', err))
}

const flagReportAsTemplate = async function (name, buildingType, description, reportId, userToken) {
  let pre = await appUrl()
  return await fetch(`${prot}:${pre}/files/flagReportAsTemplate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json'

    },
    body:JSON.stringify({type:REP_TPL, file:{ name, buildingType, description, [REP_V2]: reportId }}),
  }).catch(err => console.log('err', err))
}

export {
  createUser,
  requestArchive,
  requestUnarchive,
  requestDelete,
  getFileAsBlob,
  requestFileFromUser,
  uploadPhoto,
  reuploadPhoto,
  checkS3BucketItems,
  uploadRekognitionImagesToS3,
  testDBGEndpoints,
  _testnewws,
  fetchPost,
  fetchGet,
  LOC_ROOT,
  LOC_USER_DATA,
  appUrl,
  fetchDELETE,
  clearLangV2Tables,
  createAndAddDefaultReport,
  clearNewReportTables,
  simpleUploadImage,
  getThumbnails,
  makeAdmin,
  deduplicateReportPhotosInBlocks,
  requestExcelExport,
  toArray,
  unlockReportBlocksByUser,
  flagReportAsTemplate
}